import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import VideoCard from "../../cards/videoCard";
import Image from "../../image";

const SwiperGallery = ({
  containerClass,
  swiperRef,
  setSwiper,
  currentSwiperItem,
  setCurrentSwiper,
  gallery,
  singleFeaturedVideo = "",
  programGalleryFeaturedImage = "",
  featuredVideoGallery = [],
  swiperArrowNav = false
}) => {
  const [totalSlides, setTotalSlides] = useState(1);
  return (
    <div className={containerClass}>
      <Swiper
        ref={swiperRef}
        speed={1000}
        onSwiper={setSwiper}
        grabCursor={true}
        spaceBetween={0}
        loop={true}
        className="z-20 h-full"
        slidesPerView={1}
        navigation={swiperArrowNav}
        onSlideChange={(swiperCore) => {
          const { realIndex } = swiperCore;
          setCurrentSwiper(realIndex + 1);
          setTotalSlides(swiperCore?.slides?.length);
        }}
      >
        {singleFeaturedVideo && (
          <SwiperSlide key={"featured-program-video"}>
            <div
              className="project-video featured-video"
              dangerouslySetInnerHTML={{ __html: singleFeaturedVideo }}
            />
          </SwiperSlide>
        )}

        {programGalleryFeaturedImage && (
          <SwiperSlide key={`featured-image`}>
            <Image
              sourceUrl={programGalleryFeaturedImage}
              imageClass={"w-full h-full object-cover"}
            />
          </SwiperSlide>
        )}

        {featuredVideoGallery &&
          featuredVideoGallery.map((videos, idx) => (
            <SwiperSlide key={`featured-video-gallery-idx-${idx}`}>
              <VideoCard
                key={`featured-video-gallery-idx-item-${idx}`}
                featVideos={videos?.genVideoUrl}
                cardClass="relative bg-center bg-no-repeat bg-cover rounded-md sm:h-full grid-row-span-1 h-full py-1"
              />
            </SwiperSlide>
          ))}

        {gallery?.map((item, idx) => (
          <SwiperSlide key={`featured-gallery-image-${idx}`}>
            <Image
              sourceUrl={item?.sourceUrl}
              imageClass={"w-full h-full object-cover"}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      <div
        className={
          "bg-overlay-gallery absolute bottom-2 left-2 flex w-20 z-20 item-center justify-center rounded-xxs"
        }
      >
        <div className="relative py-2 px-5 text-white">
          {currentSwiperItem}/{totalSlides}
        </div>
      </div>
    </div>
  );
};

export default SwiperGallery;
